// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10781":"6fcf1e4a","11895":"44be7b97","18235":"34fa3ce1","45254":"dcce618b","45338":"6acdd9f7","56282":"0e93ac07","61388":"b0dd016f","68945":"36e180b4","72658":"126e42ce","85424":"868818a2"}[chunkId] + ".chunk.js";
};